import { defineMessages } from 'react-intl';

export default defineMessages({
  gtcTitle: {
    defaultMessage: 'Legal documents and privacy',
    id: 'gtc.title',
  },
});
